import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/frontier-exposure-analysis/')({
  beforeLoad: ({ context, preload }) => {
    const { validatePermissions, featureFlags, userPermissions } = context;
    const isAllowed =
      !!featureFlags[FeatureFlags.FrontierExposure] && !!userPermissions.hasAllowedPermission({ path: PAGE_PATHS.FREA_SETTINGS });
    validatePermissions({ isAllowed, preload });
  },
});
